import { takeLatest, put, call, select, all } from "redux-saga/effects";
import { createAction } from "redux-actions";
import dayjs from "dayjs";
import { api } from "../api";
import { getCommonApiParams } from "../../../../utils/redux-helpers";

export const SET_LOADING = "saga/leadStatus/SET_LOADING";
export const SET_UPDATES_LOADING = "saga/leadStatus/SET_UPDATES_LOADING";
export const SET_DATES = "saga/leadStatus/SET_DATES";
export const SET_FILTERS_DIRTY = "saga/leadStatus/SET_FILTERS_DIRTY";

const FETCH_CURRENT_USER = "saga/leadStatus/FETCH_CURRENT_USER";
export const FETCH_CURRENT_USER_SUCCESS = "saga/leadStatus/FETCH_CURRENT_USER_SUCCESS";

export const FETCH_METRICS = "saga/leadStatus/FETCH_METRICS";

const UPDATES_METRICS = "saga/leadStatus/UPDATES_METRICS";
export const UPDATE_FILTER = "saga/leadStatus/UPDATE_FILTER";
export const UPDATES_DATES = "saga/leadStatus/UPDATES_DATES";

const RESET_FILTERS = "saga/leadStatus/RESET_FILTERS";
export const RESET_FILTERS_SUCCESS = "saga/leadStatus/RESET_FILTERS_SUCCESS";

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  updateFilter: createAction(UPDATE_FILTER),
  updateDates: createAction(UPDATES_DATES),
  updateMetrics: createAction(UPDATES_METRICS),
  resetFilters: createAction(RESET_FILTERS)
};

export default function* watchLeadStatus() {
  yield takeLatest(FETCH_CURRENT_USER, fetchCurrentUserData);
  yield takeLatest(UPDATES_METRICS, updateMetrics);
  yield takeLatest(RESET_FILTERS, resetFilters);
}

function* fetchCurrentUserData({ payload: { showModule, calendarEndDate } }) {
  yield put({ type: SET_LOADING, payload: true });

  if (!showModule) {
    yield put({ type: SET_LOADING, payload: false });
    return;
  }

  let dates = getMinAndMaXDates(calendarEndDate);

  yield put({
    type: "saga/leadStatus/FETCH_CURRENT_USER_SUCCESS",
    payload: { showModule, ...dates, organizationEndDate: calendarEndDate }
  });

  yield setDates();

  try {
    yield fetchMetrics();

    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function getDatesHelper(lastAvailableDate) {
  const date = dayjs(lastAvailableDate);
  return { startDate: date.startOf("month").format("YYYY-MM-DD"), endDate: lastAvailableDate };
}

function getMinAndMaXDates(lastAvailableDate) {
  const date = dayjs(lastAvailableDate);

  return {
    calendarStartDate: date.subtract(6, "month").format("YYYY-MM-DD"),
    calendarEndDate: date.add(6, "month").format("YYYY-MM-DD")
  };
}

function* setDates() {
  const organizationEndDate = yield select(
    (state) => state.leadStatus.currentUser.organizationEndDate
  );

  let currentDates = getDatesHelper(organizationEndDate);

  yield put({
    type: SET_DATES,
    payload: currentDates
  });
}

function* fetchMetrics() {
  let { organization_id, short_url } = yield getCommonApiParams("commonReducer", "commonProps");

  let {
    dates: { startDate, endDate },
    firstBooking,
    firstVisit,
    firstEnrollment
  } = yield select((state) => state.leadStatus.selectedFilters);

  const params = {
    organization_id,
    short_url,
    start_date: startDate,
    end_date: endDate
  };

  const metrics = [
    call(api.getLeads, { params }),
    call(api.getFirstOpenBookings, { params: { ...params, sort_field: firstBooking.id } }),
    call(api.getFirstCompletedBookings, { params: { ...params, sort_field: firstVisit.id } }),
    call(api.getFirstEnrollment, { params: { ...params, sort_field: firstEnrollment.id } })
  ];

  let res = yield all(metrics);

  try {
    yield put({
      type: FETCH_METRICS,
      payload: extendMetricResponse(res.map((r) => r.data))
    });
  } catch (error) {
    console.error(error);
  }
}

const breakdownMetricFilters = {
  "First Open Booking": {
    filterKey: "firstBooking",
    filterName: "First Open Booking By"
  },
  "First Completed Visit": {
    filterKey: "firstVisit",
    filterName: "First Completed Visit By"
  },
  "First Enrollment": {
    filterKey: "firstEnrollment",
    filterName: "First Enrollment By"
  }
};

function extendMetricResponse(data) {
  return data.map((metric) => ({
    ...metric,
    ...breakdownMetricFilters[metric.title]
  }));
}

function* updateMetrics() {
  yield put({ type: SET_UPDATES_LOADING, payload: true });
  yield fetchMetrics();
  yield put({ type: SET_UPDATES_LOADING, payload: false });
}

function* resetFilters() {
  yield put({ type: SET_UPDATES_LOADING, payload: true });
  yield put({ type: SET_FILTERS_DIRTY, payload: false });

  yield put({ type: RESET_FILTERS_SUCCESS });
  yield setDates();

  yield fetchMetrics();
  yield put({ type: SET_UPDATES_LOADING, payload: false });
}
